import { IS_E2E } from '@omnipresentgroup/constants';
import { Mixpanel } from '@omnipresentgroup/mixpanel';

import { environment } from '../environment';

export const WrappedMixpanel = Mixpanel({
  prod: environment.production,
  e2e: IS_E2E,
});
